export const keyboardControl = (ItemsData: any, t: any, ref: any = null, lastFocusedElement = {current: null}) => {

    return (event: any) => {
        const div: any = ref.current
        const dropdownBtn = event.target.closest('.dx-texteditor-container')?.querySelector('.dropdown-btn') || event.target.closest('.dx-texteditor-container')?.querySelector('.dx-dropdowneditor-button')
        const lookupPopup = document.querySelector('.dx-popup-wrapper.dx-dropdowneditor-overlay')
        const lookupTitle = event.target.closest('.dx-overlay-content.dx-popup-normal')?.querySelector("div:not([class])").innerText
        const generateItems = (ItemsData: any) => {
            let elements: any[] = []

            ItemsData.map((item: any) => {
                return item.type === 'field'
                    ? div?.querySelectorAll(`[name="${item.name}"]`)[item.index]?.type === 'hidden'
                       ? div.querySelectorAll(`[name="${item.name}"]`)[item.index].parentElement.role === 'checkbox'
                            ? div.querySelectorAll(`[name="${item.name}"]`)[item.index].parentElement
                            : div?.querySelector(`[name="${item.name}"] + div`).querySelectorAll(`[role='radio']`)
                        :  div?.querySelectorAll(`[name="${item.name}"]`)[item.index]
                    : div?.querySelectorAll(`[aria-label="${item.name}"]`)[item.index] 
            }).forEach((el: any) => {

                elements = el?.length ? [...elements, ...el] : [...elements, el]
            })
            return elements
        }
        const items = generateItems(ItemsData)

        if (!lookupPopup || (lookupPopup?.querySelector('.dx-overlay-content') as any)?.style.opacity === '0') { event.stopImmediatePropagation() }

        if (event.key === 'Tab') { event.preventDefault() }

        if ((event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Tab' || event.key === 'Enter') && !event.ctrlKey && !event.altKey && !event.shiftKey && !lookupPopup) {
            const activeElement: any = lastFocusedElement.current && document.activeElement?.tagName !== 'INPUT' && (document.activeElement as any).role !== 'radiogroup' && (document.activeElement as any).role !== 'checkbox'
                ? lastFocusedElement.current
                : document.activeElement?.tagName !== 'BODY' && (document.activeElement as any).role !== 'radiogroup' && (document.activeElement as any).role !== 'checkbox' 
                    ? document.activeElement
                    : (div?.querySelector('.dx-radiobutton.dx-state-focused') || div?.querySelector('.dx-checkbox.dx-state-focused'))

            const nextItemIndex = event.key === 'ArrowUp'
                ? items.indexOf(activeElement) - 1 < 0
                    ? 0
                    : items.indexOf(activeElement) - 1
                : items.indexOf(activeElement) + 1

            if (items[nextItemIndex] === undefined || ((items[nextItemIndex]?.getAttribute('aria-readonly') === 'true' || items[nextItemIndex]?.getAttribute('aria-disabled') === 'true') && !lookupPopup)) {
                const ableToFocusItem: any = (event.key === 'ArrowUp' ? items.slice(0, nextItemIndex).reverse() : items.slice(nextItemIndex+1)).find((item: any) => {
                    return item !== undefined && item.getAttribute('aria-readonly') !== 'true' && item.getAttribute('aria-disabled') !== 'true'
                })

                ableToFocusItem?.tagName === 'TEXTAREA' && event.preventDefault()
                const prevItemIndex = items.indexOf(activeElement)
                if (ableToFocusItem) {
                    if (ableToFocusItem.role === 'radio' || ableToFocusItem.role === 'checkbox') {
                        items[prevItemIndex]?.blur()
                        if (items[prevItemIndex]?.tagName === 'INPUT') {
                            setTimeout(() => {
                                if (ableToFocusItem.role === 'radio') {ableToFocusItem.closest('.dx-field-input.dx-radiogroup').focus()}

                                ableToFocusItem.classList.add('dx-state-focused')
                                ableToFocusItem.focus()
                                lastFocusedElement.current = ableToFocusItem

                            }, 0)
                        }
                        else {
                            items[prevItemIndex]?.classList.remove('dx-state-focused')
                            ableToFocusItem.classList.add('dx-state-focused')
                            ableToFocusItem.focus()
                            lastFocusedElement.current = ableToFocusItem
                        }
                    }
                    else {
                        lastFocusedElement.current = ableToFocusItem
                        items[prevItemIndex]?.classList.remove('dx-state-focused')
                        ableToFocusItem.focus()
                    }
                } 
                else {
                    (items[prevItemIndex]?.role === 'checkbox' || items[prevItemIndex]?.role === 'radio') && items[prevItemIndex]?.classList.remove('dx-state-focused')
                    // if no next item is available find the first available item and focus it
                    const firstItem = items.find((item: any) => item !== undefined && !item.getAttribute('aria-readonly') && !item.getAttribute('aria-disabled'))
                    firstItem?.focus()
                    lastFocusedElement.current = firstItem
                }
            }
            else {
                if (!lookupPopup) {
                    items[nextItemIndex]?.tagName === 'TEXTAREA' && event.preventDefault()
                    const itemForFocus = items[items.length === nextItemIndex ? 0 : nextItemIndex]
                    const prevItemIndex = items.indexOf(activeElement)
                    if (itemForFocus.role === 'radio' || itemForFocus.role === 'checkbox') {
                        items[prevItemIndex]?.blur()
                        
                        if (items[prevItemIndex]?.tagName === 'INPUT') {
                            setTimeout(async() => {
                                if (itemForFocus.role === 'radio') {itemForFocus.closest('.dx-field-input.dx-radiogroup').focus()}
                                
                                itemForFocus.classList.add('dx-state-focused')
                                itemForFocus.focus()
                                lastFocusedElement.current = itemForFocus
                            }, 0)
                        }
                        else {
                            items[prevItemIndex]?.classList.remove('dx-state-focused')
                            itemForFocus.classList.add('dx-state-focused')
                            itemForFocus.focus()
                            lastFocusedElement.current = itemForFocus
                        }
                    }
                    else {
                        (items[prevItemIndex]?.role === 'checkbox' || items[prevItemIndex]?.role === 'radio') && items[prevItemIndex]?.classList.remove('dx-state-focused')
                        lastFocusedElement.current = itemForFocus
                        !sessionStorage.getItem('fieldValue') && itemForFocus.focus()
                    }
                }
            }
        }

        if (event.key === 'F2') { dropdownBtn?.click() }

        if (event.key === 'Escape') {
            const dropDown = document.querySelector('.dx-popup-wrapper.dx-dropdowneditor-overlay')
            const cancelButton: any = document.querySelectorAll(`.dx-popup-wrapper [aria-label="${t('global:button.cancel')}"]`)

            if(!cancelButton.length && dropDown) {
                dropdownBtn?.click()
            }

            cancelButton[cancelButton.length - 1]?.click()
            const fieldData = ItemsData.find((item: any) => item.name === lookupTitle)
            const field: any = div?.getElementsByName ? div?.getElementsByName(fieldData?.name)[fieldData?.index] : null


            if(!fieldData && lookupTitle === 'OBJNR') {
                document.getElementsByName('OBJNR')[1].focus()
            }
            setTimeout(() => {field?.focus()}, 0)
        }

        if (event.ctrlKey && event.key === 'Enter') {
            const saveButton: any = document.querySelector(`[aria-label="${t('global:button.save')}"]`)
            const createButton: any = document.querySelector(`[aria-label="${t('global:button.create')}"]`)

            saveButton?.click()
            createButton?.click()
        }

        if (event.altKey && event.key === 'Enter' && event.target.tagName === 'TEXTAREA') {
            event.target.value = `${event.target.value}\r\n`
            event.target.style.height = `${event.target.clientHeight + 20}px`
        }

        if ((event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Tab' && event.key !== 'Enter' && event.key !== 'Escape' && event.key !== 'F2' && event.code !== 'Space')){
            const activeElement: any = div?.querySelector('.dx-radiobutton.dx-state-focused') || div?.querySelector('.dx-checkbox.dx-state-focused')
            activeElement && activeElement.click()
        }

        if (event.code === 'Space' && (lastFocusedElement.current as any)?.getAttribute('aria-checked') === 'true') {
            (lastFocusedElement.current as any).click()
        }
    }
}
